"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.getCountOfVariantInCart = void 0;
var get_1 = require("./get");
var getCountOfVariantInCart = function (variantId) { return (0, get_1.getCurrentCart)().items.reduce(function (x, item) {
    if (item.variant_id != variantId)
        return x;
    return x += item.quantity;
}, 0); };
exports.getCountOfVariantInCart = getCountOfVariantInCart;
//# sourceMappingURL=count.js.map